import { PageHeader, PageHeaderRight } from "@app/shared";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { memo } from "react";
import { useParams } from "react-router-dom";

function nonMemoProviderNetworkImportHeader() {
  const { networkId } = useParams<{ networkId?: string }>();

  return (
    <PageHeader title="Provider Network Import" disableHR={true} iconName={QesIcons.FontAwesome.UserMd}>
      <PageHeaderRight>
        <div className="page-title-bar">
          <div className="ml-auto">
            <a href={`${window.uiEndpoint}/data/providersets/${networkId}`} className="qes-button qes-button-primary mt-1 mr5" type="button">Provider Network Summary</a>
          </div>
        </div>
      </PageHeaderRight>
    </PageHeader>
  );
}

export const ProviderNetworkImportHeader = memo(nonMemoProviderNetworkImportHeader);
